import React from 'react';

export const My = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='34'
            height='34'
            viewBox='0 0 34 34'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M19.7213 5.13806C19.883 5.08431 20.0501 5.20405 20.0504 5.37439V28.6254C20.0503 28.7957 19.883 28.9163 19.7213 28.8627L9.32092 25.3959C9.21887 25.3619 9.15007 25.2661 9.15002 25.1586V8.84119C9.15016 8.7337 9.21893 8.63788 9.32092 8.60388L19.7213 5.13806Z'
                stroke='currentColor'
                strokeWidth='3.5'
            />
            <path
                d='M24.2 9.20002C24.2 8.20591 25.0059 7.40002 26 7.40002C26.9941 7.40002 27.8 8.20591 27.8 9.20002V24.8C27.8 25.7941 26.9941 26.6 26 26.6C25.0059 26.6 24.2 25.7941 24.2 24.8V9.20002Z'
                fill='currentColor'
            />
        </svg>
    );
};

export default My;
